import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import Webcam from "react-webcam";
import { CameraOutlined, SyncOutlined, CloseOutlined } from "@ant-design/icons";
import { Image, Modal } from "antd";

const PhotoCapture = ({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) => {
  const [photoModal, setPhotoModal] = useState(false);
  const [hasCamera, setHasCamera] = useState(true);
  const [permissionError, setPermissionError] = useState('');
  const [faceMode, setFaceMode] = useState("user");
  const videoConstraints = {
    facingMode: faceMode,
  };
  const [element, setElement] = useState({
    type: "capturephoto",
    properties: {
      label: "Enter label Name here...",
      placeholder: "Enter label Name here...",
      required: true,
    },
    value: {
      src: null,
      name: null,
    },
  });

  useEffect(() => {
    async function checkCamera() {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some((d) => d.kind === "videoinput");
        setHasCamera(hasVideoInput);
      } catch (err) {
        console.error("Error checking camera:", err);
        setHasCamera(false);
      }
    }
    checkCamera();
  }, []);

  useEffect(() => {
    setElement((prev) => {
      return {
        ...prev,
        ...data,
      };
    });
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => {
    //     return {
    //       ...prev,
    //       ...data,
    //     };
    //   });
    // }
  }, [data, isChild]);

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  const isDisabled = element?.isPhotoRestrict || approve || !element.editable;

  return (
    <div
      className="form-group col-md-12 form-builder-element mb-3 form-view"
      data={JSON.stringify(element)}
    >
      <div className="">
        <label htmlFor="">
          {element.properties.label}
          <If
            test={
              element.properties.required === true &&
              element?.isMandate === undefined
            }
          >
            <span style={{ color: "red" }}>*</span>
          </If>
        </label>
        {!hasCamera ? (
          <div className="text-danger">
            🚫 No camera detected on this device
          </div>
        ) : (
          <div>
            {element?.value?.src && (
              <>
                <p>{element?.value?.name}</p>
              </>
            )}
            <button
              disabled={isDisabled}
              className={`btn-sm ${
                isDisabled ? "btn-secondary" : "btn-primary"
              }`}
              onClick={(e) => setPhotoModal(true)}
            >
              <CameraOutlined style={{}} />{" "}
              {element?.value?.src ? "Preview" : "Take"} Photo
            </button>
            {data?.value?.name && (
              <span style={{ color: "#38E54D" }}>
                {data?.value?.name + " - Completed"}
              </span>
            )}
          </div>
        )}

        {foundError && <span className="text-danger">{foundError?.value}</span>}
      </div>
      <Modal
        title={null}
        width={300}
        closable={false}
        open={photoModal}
        footer={null}
        style={{
          padding: 0,
          borderRadius: "12px",
          overflow: "hidden",
          backgroundColor: "black",
        }}
        bodyStyle={{
          padding: "0",
          backgroundColor: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        destroyOnClose
      >
        <div style={{ width: "100%", height: "100%", textAlign: "center",position:'relative' }}>
          {element?.value?.src ? (
            <>
              <div style={{ marginTop: "8px" }}>
                <Image
                  src={element?.value?.src}
                  style={{
                    width: "100%",
                    height: "332px",
                    borderRadius: "8px",
                    objectFit: "contain",
                  }}
                />
                <div
                  className="d-flex justify-content-center my-3"
                  style={{
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-danger rounded-pill font-weight-bold px-3 py-2"
                    onClick={() => {
                      setElement((prev) => {
                        return {
                          ...prev,
                          value: null,
                          name: null,
                        };
                      });
                    }}
                  >
                    Retake
                  </button>
                  <button
                    className="btn btn-success rounded-pill font-weight-bold px-3 py-2"
                    onClick={() => {
                      setPhotoModal(false);
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Webcam
                audio={false}
                height={400}
                screenshotFormat="image/png"
                width={"100%"}
                videoConstraints={videoConstraints}
                style={{
                  borderRadius: "12px",
                  objectFit: "contain",
                }}
                    onUserMediaError={(err) => {
                    console.error("Camera error:", err);
                    setPermissionError('Lock icon 🔒 in the address bar → Site settings → Camera → Allow.')
                  }}
              >
                {({ getScreenshot }) => (
                  <div
                    className="d-flex justify-content-between align-items-center p-2 position-absolute w-100"
                    style={{
                      background: "rgba(0,0,0,0.6)",
                      bottom: "0",
                      position: "relative",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-center align-items-center">
                      <button
                        className="d-flex justify-content-center align-items-center bg-white rounded-circle border border-white"
                        style={{
                          width: "50px",
                          height: "50px",
                          borderWidth: "4px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const imageSrc = getScreenshot();
                          setElement((prev) => {
                            return {
                              ...prev,
                              value: {
                                name: `captured-photo-${new Date().getTime()}.png`,
                                src: imageSrc,
                              },
                            };
                          });
                        }}
                      />
                    </div>
                    <button
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: "white",
                        right: 10,
                        position: "absolute",
                      }}
                      onClick={() => {
                        setFaceMode((prev) => {
                          return prev === "user" ? "environment" : "user";
                        });
                      }}
                    >
                      <SyncOutlined
                        style={{ fontSize: "1.8rem", color: "white" }}
                      />
                    </button>
                  </div>
                )}
              </Webcam>
            </>
          )}
          {
            !element?.value?.src &&
            <button
              className="btn rounded-pill font-weight-bold"
              style={{
                position : 'absolute',
                right:10,
                top:10,
                color:'#fff',
                fontSize:'1.5rem'
              }}
              onClick={() => {
                setPhotoModal(false);
              }}
            >
              <CloseOutlined />
            </button>
          }
          {permissionError &&
            <div className="p-1" style={{color:'#fff',width:'70%',position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}>
              <div>
                <strong style={{fontSize:'1.2rem',marginBottom:'0.5rem'}}>Permission Denied</strong>
                <p>
                  {permissionError}
                </p>
              </div>
            </div>
          }
        </div>
      </Modal>
    </div>
  );
};

export default PhotoCapture;
